import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7e1ab3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-12 text-center wow fadeIn\" data-wow-delay=\"300ms\" data-v-c7e1ab3a><h2 class=\"heading bottom40 darkcolor font-light2\" data-v-c7e1ab3a><span class=\"font-normal\" data-v-c7e1ab3a>Registrasi</span><span class=\"divider-center\" data-v-c7e1ab3a></span></h2><div class=\"col-md-8 offset-md-2 heading_space\" data-v-c7e1ab3a><p data-v-c7e1ab3a></p></div></div>", 1)
const _hoisted_2 = { class: "col-lg-6 col-md-12 col-sm-12 pr-lg-0 whitebox noshadow" }
const _hoisted_3 = {
  key: 0,
  class: "widget logincontainer"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "darkcolor bottom35 text-center text-md-left" }, "Buat Akun", -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-12 col-sm-12" }
const _hoisted_7 = { class: "form-group bottom25" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "registerName",
  class: "d-none"
}, null, -1))
const _hoisted_9 = { class: "col-md-12 col-sm-12" }
const _hoisted_10 = { class: "form-group bottom25" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "nikNpwp",
  class: "d-none"
}, null, -1))
const _hoisted_12 = { class: "col-md-12 col-sm-12" }
const _hoisted_13 = { class: "form-group bottom25" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "registerEmail",
  class: "d-none"
}, null, -1))
const _hoisted_15 = { class: "col-md-12 col-sm-12" }
const _hoisted_16 = { class: "form-group bottom25" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "registerPass",
  class: "d-none"
}, null, -1))
const _hoisted_18 = { class: "col-md-12 col-sm-12" }
const _hoisted_19 = { class: "form-group bottom25" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "registerPassConfirm",
  class: "d-none"
}, null, -1))
const _hoisted_21 = { class: "col-md-12 col-sm-12" }
const _hoisted_22 = { class: "form-group bottom25" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "registerPassConfirm",
  class: "d-none"
}, null, -1))
const _hoisted_24 = { class: "col-md-12 col-sm-12" }
const _hoisted_25 = { class: "form-group bottom25 text-center" }
const _hoisted_26 = { class: "d-flex w-100 justify-content-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "button gradient-btn w-100"
  }, " Daftar "),
  /*#__PURE__*/_createElementVNode("p", { class: "top20 log-meta" }, [
    /*#__PURE__*/_createTextVNode(" Sudah Memiliki akun ?  "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "/login",
      class: "defaultcolor"
    }, "Masuk")
  ])
], -1))
const _hoisted_28 = {
  key: 1,
  class: "bg-white"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/img/success-unscreen.gif",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-md-12 text-center",
    style: {"text-align":"center !important"}
  }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "darkcolor bottom35 text-center" }, "Registrasi Berhasil"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Silahkan cek email anda untuk melakukan verifikasi akun ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "mt-5" })
  ])
], -1))
const _hoisted_30 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_RecaptchaV2 = _resolveComponent("RecaptchaV2")!
  const _component_Form = _resolveComponent("Form")!
  const _component_b_overlay = _resolveComponent("b-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_b_overlay, {
        show: _ctx.loadingCard,
        rounded: "sm"
      }, {
        default: _withCtx(() => [
          (!_ctx.successRegister)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_Form, {
                  class: "border-form",
                  id: "register",
                  "validation-schema": _ctx.schema,
                  onSubmit: _ctx.submitRegister
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _hoisted_8,
                          _createVNode(_component_Field, {
                            class: "form-control",
                            name: "name",
                            type: "text",
                            placeholder: "Nama Lengkap :",
                            modelValue: _ctx.registerData.name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.registerData.name) = $event)),
                            style: {"margin":"0px !important"}
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            class: "text-danger",
                            name: "name"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createVNode(_component_Field, {
                            class: "form-control",
                            type: "text",
                            name: "nik_npwp",
                            placeholder: "NIK / NPWP :",
                            modelValue: _ctx.registerData.nik_npwp,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.registerData.nik_npwp) = $event)),
                            style: {"margin":"0px !important"},
                            maxlength: "16"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            class: "text-danger",
                            name: "nik_npwp"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createVNode(_component_Field, {
                            class: "form-control",
                            type: "email",
                            name: "email",
                            placeholder: "Email :",
                            modelValue: _ctx.registerData.email,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.registerData.email) = $event)),
                            style: {"margin":"0px !important"}
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            class: "text-danger",
                            name: "email"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _createVNode(_component_Field, {
                            class: "form-control",
                            type: "password",
                            name: "password",
                            placeholder: "Password :",
                            modelValue: _ctx.registerData.password,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.registerData.password) = $event)),
                            style: {"margin":"0px !important"}
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            class: "text-danger",
                            name: "password"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _createVNode(_component_Field, {
                            class: "form-control",
                            type: "password",
                            name: "confirm_password",
                            placeholder: "Konfirmasi Password :",
                            modelValue: _ctx.registerData.confirm_password,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.registerData.confirm_password) = $event)),
                            style: {"margin":"0px !important"}
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            class: "text-danger",
                            name: "confirm_password"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createVNode(_component_Field, {
                            class: "form-control",
                            type: "text",
                            name: "nomor_kontak",
                            placeholder: "Nomor Kontak :",
                            modelValue: _ctx.registerData.nomor_kontak,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.registerData.nomor_kontak) = $event)),
                            style: {"margin":"0px !important"}
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            class: "text-danger",
                            name: "nomor_kontak"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_RecaptchaV2, {
                              onWidgetId: _ctx.handleWidgetId,
                              onErrorCallback: _ctx.handleErrorCalback,
                              onExpiredCallback: _ctx.handleExpiredCallback,
                              onLoadCallback: _ctx.handleLoadCallback,
                              language: "id"
                            }, null, 8, ["onWidgetId", "onErrorCallback", "onExpiredCallback", "onLoadCallback"])
                          ])
                        ])
                      ]),
                      _hoisted_27
                    ])
                  ]),
                  _: 1
                }, 8, ["validation-schema", "onSubmit"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ], 64))
}